import React from 'react'
import ErrorPage from 'dialogs/ErrorPage'
import {handleError} from 'common/ErrorHandler'


export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorHappened: false
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            errorHappened: !!errorInfo
        });

        const errorDescription = error.stack || error.message || error;
        handleError(errorDescription);
    }

    render() {
        if (this.state.errorHappened) {
            return <ErrorPage/>
        }
        return this.props.children;
    }
}


// WEBPACK FOOTER //
// ./src/common/ErrorBoundary/index.js